
import { z } from "zod";

// Schema voor validatie
export const medewerkerSchema = z.object({
  naam: z.string().min(2, "Naam moet minimaal 2 karakters bevatten"),
  roepnaam: z.string().optional(),
  functie: z.string().optional(),
  afdeling: z.string().optional(),
  email: z.string().email("Ongeldig e-mailadres").optional().or(z.literal("")),
  username: z.string().min(2, "Gebruikersnaam moet minimaal 2 karakters bevatten"),
  password: z.string().min(6, "Wachtwoord moet minimaal 6 karakters bevatten").optional(),
  role: z.enum(["medewerker", "planner", "management"]).default("medewerker"),
});

export type MedewerkerFormValues = z.infer<typeof medewerkerSchema>;
